<template>
  <div class="tab" v-show="isActive" :class="rootCss">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    withHeightLimit: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "Tab",
    },
  },
  data() {
    return {
      isActive: true,
    };
  },
  computed: {
    rootCss() {
      return {
        'height-limit': this.withHeightLimit,
      };
    },
  },
};
</script>

<style scoped>
.tab {
  overflow-x: hidden;
  overflow-y: auto;
}

.tab::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #337ab7;
}

.tab::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: transparent;
}

.tab::-moz-scrollbar-thumb {
  border-radius: 10px;
  background-color: #337ab7;
}

.tab::-moz-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: transparent;
}

.tab::-o-scrollbar-thumb {
  border-radius: 10px;
  background-color: #337ab7;
}

.tab::-o-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: transparent;
}

.tab::-webkit-scrollbar {
  width: 0.3em;
  background-color: transparent;
}

@media (max-width: 767px) {
  .height-limit {
    max-height: 14em;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Tab.vue